import React, { useState } from 'react';

import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Button } from 'components/index';
import { getLinkedReports } from '../project/project.api';
import { toast } from 'react-toastify';
import { Close } from '@mui/icons-material';

interface DeletionHandlerProps {
  open: boolean;
  item: any; // Adjust the type based on your item structure
  data?: any;
  deleteFunction: (...args: string[]) => Promise<any>;
  onDeleteConfirm: (id: string, message: string) => void;
  onClose: () => void;
}
const checkForLinkedReports = async (projectId: string) => {
  try {
    const linkedReports = await getLinkedReports(projectId);
    return linkedReports.length > 0;
  } catch (error) {
    console.error('Error fetching linked reports:', error);
    return false; // or handle error appropriately
  }
};
function DeletionHandler({ open, item, data, deleteFunction, onDeleteConfirm, onClose }: DeletionHandlerProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (item.isNote) {
      // Check if the item is a note
      try {
        const response = await deleteFunction(item.reportId, item.id); // deleteFunction now expects two arguments for note deletion
        onDeleteConfirm(item.id, response.message || response);
      } catch (error) {
        console.error('Deletion error:', error);
      }
    } else {
      setIsLoading(true);

      if (item.projectNumber || item.ProjectNumber) {
        const projectId = item.projectId || item.Id;
        const hasLinkedReports = await checkForLinkedReports(projectId);
        if (hasLinkedReports) {
          toast.error('Cannot delete this project as it has linked reports.');
          setIsLoading(false);
          return;
        }
      }

      const deletionId = item.projectNumber || item.ProjectNumber || item.id;
      try {
        const response = await deleteFunction(deletionId);
        onDeleteConfirm(deletionId, response.message || response);
      } catch (error) {
        console.error('Deletion error:', error);
      }
      setIsLoading(false);
    }
  };

  const deletionContent = () => {
    if (data) {
      return data;
    }

    // Check for both variations of projectNumber and projectTitle
    const projectNumber = item.projectNumber || item.ProjectNumber;
    const projectTitle = item.projectTitle || item.ProjectTitle;
    const reportName = item.reportName;

    // Return formatted string based on available data
    if (projectNumber) {
      return `project '${projectNumber} - ${projectTitle}'`;
    } else if (reportName) {
      return `report '${reportName}'`;
    } else {
      return 'Unknown Item';
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        Delete Confirmation
        <IconButton onClick={onClose} sx={{ marginLeft: 'auto' }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>Are you sure you want to delete {deletionContent()} ?</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined' color='primary' disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleDelete} variant='contained' color='error' disabled={isLoading}>
          {isLoading && <CircularProgress size={24} color='inherit' style={{ marginRight: '10px' }} />}
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeletionHandler;
